import commonConstant from '../../common/_commonConstant';

export const getBuilding = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getBuildingBySearch = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_BUILDING_BY_SEARCH_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_BUILDING_BY_SEARCH_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getBuildingByRefNo = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_BUILDING_BY_ID_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_BUILDING_BY_ID_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getDraftBuilding = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_DRAFT_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_DRAFT_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const createDraftBuilding = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_DRAFT_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_DRAFT_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const createBuilding = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const updateBuilding = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
